/** @jsxImportSource @emotion/react */
import { Fragment } from "react";
import { Card } from "primereact/card";
import { formatMonto } from "../../utils";

export default function CardTotalesPendientes({ facturas }) {
  if (!facturas || facturas.length === 0) return null;

  const pendientes = facturas.filter(
    (f) => !f.fechaPago && !f.anulada
  );

  if (pendientes.length === 0) {
    return (
      <Card
        css={{
          backgroundColor: "var(--green-50)",
          border: "1px solid var(--green-200)",
          marginBottom: "1em"
        }}
      >
        <div
          css={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
        >
          <i
            className="pi pi-check-circle"
            css={{ fontSize: "1.5rem", color: "var(--green-600)" }}
          />
          <div css={{ fontWeight: "bold", color: "var(--green-700)" }}>
            Todas las facturas están pagas
          </div>
        </div>
      </Card>
    );
  }

  const totalesPorMoneda = new Map();
  let orden = 0;
  for (const f of pendientes) {
    const simbolo = f.moneda?.simbolo || "";
    const key = f.moneda?.id ?? f.moneda?.nombre ?? simbolo;
    if (!totalesPorMoneda.has(key)) {
      totalesPorMoneda.set(key, {
        simbolo,
        conIva: 0,
        sinIva: 0,
        orden: orden++
      });
    }
    const entry = totalesPorMoneda.get(key);
    if (f.masIva) entry.conIva += f.monto || 0;
    else entry.sinIva += f.monto || 0;
  }

  const items = [];
  for (const t of [...totalesPorMoneda.values()].sort(
    (a, b) => a.orden - b.orden
  )) {
    if (t.conIva > 0)
      items.push({ simbolo: t.simbolo, total: t.conIva, masIva: true });
    if (t.sinIva > 0)
      items.push({ simbolo: t.simbolo, total: t.sinIva, masIva: false });
  }

  return (
    <Card
      css={{
        backgroundColor: "var(--yellow-50)",
        border: "1px solid var(--yellow-200)",
        marginBottom: "1em"
      }}
    >
      <div css={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
        <i
          className="pi pi-clock"
          css={{ fontSize: "1.5rem", color: "var(--yellow-600)" }}
        />
        <div>
          <div css={{ fontWeight: "bold", color: "var(--yellow-700)" }}>
            Totales pendiente de pago
          </div>
          <div
            css={{
              color: "var(--yellow-700)",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "0.75em"
            }}
          >
            {items.map((it, i) => (
              <Fragment key={i}>
                {i > 0 && (
                  <span
                    css={{
                      display: "inline-block",
                      width: "1px",
                      height: "1.2em",
                      backgroundColor: "var(--yellow-600)",
                      opacity: 0.4
                    }}
                  />
                )}
                <span>
                  {it.simbolo} {formatMonto(it.total)}
                  {it.masIva ? " + IVA" : ""}
                </span>
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
}
